import { differenceInSeconds } from 'date-fns';

import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { MODERATOR_ROLES } from '../../constants/reviews';
import { ICommentItem, IReviewItem } from '../../interfaces/reviews';
import { getFormattedDate } from '../../utils/dateTime';
import { UserAvatar } from '../UserAvatar';

interface IProps {
  entity: IReviewItem | ICommentItem;
  isBankAnswer?: boolean;
  isList?: boolean;
  showAvatar?: boolean;
  logo?: string;
}

export const AuthorInfo: React.FC<IProps> = ({ entity, isBankAnswer, isList, showAvatar = true, logo }) => {
  const isMobile = useIsMobile();

  if (!entity) return null;

  const { date, userId, authorName, authorRole, isSravniClient, isAuthorDeleted } = entity;
  const { organizationLogotypes } = entity as ICommentItem;

  const isModerator = MODERATOR_ROLES.includes(authorRole);

  return (
    <Space size={12} align={isMobile || !isList ? 'start' : 'center'}>
      {showAvatar && !isAuthorDeleted && (
        <UserAvatar
          userId={userId}
          isRepresentative={isBankAnswer}
          isBankAnswer={isBankAnswer}
          logo={organizationLogotypes?.square ?? logo}
        />
      )}
      <Space
        direction={isMobile || !isList ? 'vertical' : 'horizontal'}
        align={isMobile || !isList ? 'start' : 'center'}
        inline
      >
        {isAuthorDeleted ? (
          <Typography.Text size={14} strong className={'h-color-D100'} nowrap>
            Удаленный пользователь
          </Typography.Text>
        ) : (
          <Space direction={isMobile ? 'vertical' : 'horizontal'}>
            <Typography.Text size={14} strong className={'h-color-D100'} nowrap>
              {authorName}
            </Typography.Text>
            {isSravniClient && (
              <Typography.Text nowrap className={'h-color-D30'}>
                {!isMobile && ', '}
                клиент Сравни
              </Typography.Text>
            )}
          </Space>
        )}
        <Space
          size={isMobile ? 0 : 8}
          direction={isMobile ? 'vertical' : 'horizontal'}
          className={isMobile || !isList ? '' : 'h-ml-12'}
        >
          {!isList && isModerator && (
            <Typography.Text size={14} className="h-color-D100">
              Модератор Сравни
            </Typography.Text>
          )}
          <Typography.Text size={14} className="h-color-D30" nowrap>
            {differenceInSeconds(new Date(), new Date(date)) < 120 ? 'только что' : getFormattedDate(date)}
          </Typography.Text>
        </Space>
      </Space>
    </Space>
  );
};
